import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import moment from "moment";
import "moment/locale/es";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

export const Liquidacion = ({ liquidaciones, vam }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    const periodo = id => {
        let ret;
        id = id.toString();
        switch (id) {
            case "1":
                ret = "MENSUAL";
                break;
            case "2":
                ret = "BIMENSUAL";
                break;
            case "3":
                ret = "TRIMESTRAL";
                break;
            case "4":
                ret = "CORRIENTE";
                break;
            case "5":
                ret = "DIFERIDO";
                break;
            case "6":
                ret = "INMEDIATO";
                break;
            case "0":
                ret = "INMEDIATO";
                break;
            default:
                ret = "7";
                break;
        }
        return ret;
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Liquidación"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th className="text-left">Item</th>
                                        <th className="text-left">Forma Pago</th>
                                        <th className="text-left">Fc Liquida</th>
                                        <th className="text-left">Valor</th>
                                        <th className="text-left">Fc Docum</th>
                                        <th className="text-left">Banco</th>
                                        <th className="text-left">Cheque</th>
                                        <th className="text-left">Cta Cte</th>
                                        <th className="text-left">Tipo Pago</th>
                                        <th className="text-left">Observaciones</th>
                                        <th className="text-left">Finiquito</th>
                                        <th className="text-left">Fecha Anticipo</th>
                                        <th className="text-right">Valor Anticipo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {liquidaciones.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={13}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {liquidaciones.map((item, index) => (
                                                <tr key={item.cdPago}>
                                                    <td>
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.formaPago}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>
                                                            {item.fcPago
                                                                ? moment(item.fcPago)
                                                                      .locale("moment/locale/es")
                                                                      .local()
                                                                      .format("DD/MMM/YYYY")
                                                                : null}
                                                        </span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.valPago}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>
                                                            {item.fcDocPago
                                                                ? moment(item.fcDocPago)
                                                                      .locale("moment/locale/es")
                                                                      .local()
                                                                      .format("DD/MMM/YYYY")
                                                                : null}
                                                        </span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.banco}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.cheque}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.ctaCte}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.dscRubro}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.obsPago}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.finiquito ? "NO" : "SI"}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>
                                                            {item.fcPagoSol
                                                                ? moment(item.fcPagoSol)
                                                                      .locale("moment/locale/es")
                                                                      .local()
                                                                      .format("DD/MMM/YYYY")
                                                                : null}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <ReactNumeric
                                                            valuex={item.valorSol ? item.valorSol : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
